import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    overflowHidden: {
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
    },
    termosDeUso: {
        width: '100%',
        color: theme.palette.text.primary,
        fontSize: '1rem',
        textAlign: 'justify',
        flex: 1,
        height: '0',
        overflowY: 'auto',
        '& table': {
            width: '100%'
        },
        '& td': {
            padding: theme.spacing(1, 2),
        },
        border: '1px solid ' + theme.palette.divider,
        padding: theme.spacing(2),
        borderRadius: theme.shape.borderRadius,
    },
    buttonSpace: {
        flex: '0 0 auto',
        padding: theme.spacing(2, 0),
    },
    contentCenter: {
        display: 'flex',
        maxHeight: '100%',
        justifyContent: 'center',
    }
}))